import { guid } from '../util/helpers'

const fields = {
  basic: []
}

function seed () {
  const basic = [
    { name: 'Name and surname', type: 'text', value: '', hidden: false },
    { name: 'Position', type: 'text', value: '', hidden: false },
    { name: 'Phone1', type: 'phone', value: '', hidden: false },
    { name: 'Phone2', type: 'phone', value: '', hidden: false },
    { name: 'Email', type: 'email', value: '', hidden: false },
    { name: 'Show Office Address', type: 'checkbox', value: '', hidden: false },
    { name: 'Address', type: 'text', value: '', hidden: true }
  ]

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() })
  })

  addPlaceholder()
}

function addPlaceholder () {
  const placeholders = [
    'Stefan Docplanner',
    'Corridor developer',
    '+ 1 123 456 7890',
    '+ 1 123 456 7891',
    'mail@docplanner.com',
    0,
    null,
  ]

  fields.basicPlaceholder = [
    ...fields.basic.map((item, index) => {
      return { ...item, value: placeholders[index] }
    })
  ]
}

seed()

export default fields
